import { render } from "./ProvidorPage.vue?vue&type=template&id=7361c556&ts=true"
import script from "./ProvidorPage.vue?vue&type=script&lang=ts"
export * from "./ProvidorPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__